/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import MaintenanceService from "../../service/MaintenanceService";
import autoTable from "jspdf-autotable";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import CustomLtrSetup from "../../models/CustomLtrSetup";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Link } from "react-router-dom";

interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prefix: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    suffix: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    template: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    itemClassCode: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    capacityCode: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    description: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    minuteEntryRequired: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    cutCostRequired: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    numberOfColorsRequired: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    numberOfApplicationsRequired: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    retailPriceRequired: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    sewCostRequired: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    stoneCostRequired: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    colorRequired: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    allstarItemClassCode: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    status: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
};

export default function CustomLtrSetupView() {
    let empty: CustomLtrSetup = {
        prefix: '',
        suffix: '',
        template: '',
        itemClassCode: '',
        capacityCode: '',
        description: '',
        minuteEntryRequired: 0,
        cutCostRequired: 0,
        numberOfColorsRequired: 0,
        numberOfApplicationsRequired: 0,
        retailPriceRequired: 0,
        sewCostRequired: 0,
        stoneCostRequired: 0,
        colorRequired: 0,
        allstarItemClassCode: '',
        rowId: 0,
        status: ''
    };

    const status: DropdownItem[] = useMemo(
        () => [
            { name: 'Active', code: 'A' },
            { name: 'Deleted', code: 'D' }
        ],
        []
    );

    const [listValues, setListValues] = useState<CustomLtrSetup[]>([]);
    const [singleValue, setSingleValue] = useState<CustomLtrSetup>(empty);
    const [listFilteredData, setListFilteredData] = useState<CustomLtrSetup[]>([]);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const dt = useRef<any>(null);

    useEffect(() => {
        initFilters();
        MaintenanceService.getCustomLtrSetups().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        MaintenanceService.getCustomLtrSetups().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: CustomLtrSetup) => [
            item.prefix,
            item.suffix,
            item.template,
            item.itemClassCode,
            item.capacityCode,
            item.description,
            item.minuteEntryRequired ? 'Yes' : 'No',
            item.cutCostRequired ? 'Yes' : 'No',
            item.numberOfColorsRequired ? 'Yes' : 'No',
            item.numberOfApplicationsRequired ? 'Yes' : 'No',
            item.retailPriceRequired ? 'Yes' : 'No',
            item.sewCostRequired ? 'Yes' : 'No',
            item.stoneCostRequired ? 'Yes' : 'No',
            item.colorRequired ? 'Yes' : 'No',
            item.allstarItemClassCode,
            item.status,
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Prefix', 'Suffix', 'Template', 'Item Class Code', 'Capacity Code', 'Description', 'Minute Entry Required', 'Cut Cost Required', 'Number Of Colors Required', 'Number Of Applications Required', 'Retail Price Required', 'Sew Cost Required', 'Stone Cost Required', 'Color Required', 'Allstar Item Class Code', 'Status']], body: bodyData })
                doc.save('customLtrSetups.pdf');
            });
        });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const prefixTemplate = (rowData: CustomLtrSetup) => {
        return rowData.prefix;
    };

    const suffixTemplate = (rowData: CustomLtrSetup) => {
        return rowData.suffix;
    };

    const templateTemplate = (rowData: CustomLtrSetup) => {
        return rowData.template;
    };

    const itemClassCodeTemplate = (rowData: CustomLtrSetup) => {
        return rowData.itemClassCode;
    };

    const capacityCodeTemplate = (rowData: CustomLtrSetup) => {
        return rowData.capacityCode;
    };

    const descriptionTemplate = (rowData: CustomLtrSetup) => {
        return rowData.description;
    };

    const minuteEntryRequiredTemplate = (rowData: CustomLtrSetup) => {
        if (rowData.minuteEntryRequired) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const cutCostRequiredTemplate = (rowData: CustomLtrSetup) => {
        if (rowData.cutCostRequired) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const numberOfColorsRequiredTemplate = (rowData: CustomLtrSetup) => {
        if (rowData.numberOfColorsRequired) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const numberOfApplicationsRequiredTemplate = (rowData: CustomLtrSetup) => {
        if (rowData.numberOfApplicationsRequired) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const retailPriceRequiredTemplate = (rowData: CustomLtrSetup) => {
        if (rowData.retailPriceRequired) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const sewCostRequiredTemplate = (rowData: CustomLtrSetup) => {
        if (rowData.sewCostRequired) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const stoneCostRequiredTemplate = (rowData: CustomLtrSetup) => {
        if (rowData.stoneCostRequired) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const colorRequiredTemplate = (rowData: CustomLtrSetup) => {
        if (rowData.colorRequired) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const allstarItemClassCodeTemplate = (rowData: CustomLtrSetup) => {
        return rowData.allstarItemClassCode;
    };

    const statusTemplate = (rowData: CustomLtrSetup) => {
        return rowData.status;
    };

    const clearNew = () => {
        form.reset();
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };

        _value.prefix = data.prefix;
        _value.suffix = data.suffix;
        _value.template = data.template;
        _value.itemClassCode = data.itemClassCode;
        _value.capacityCode = data.capacityCode;
        _value.description = data.description;
        _value.minuteEntryRequired = data.minuteEntryRequired ? 1 : 0;
        _value.cutCostRequired = data.cutCostRequired ? 1 : 0;
        _value.numberOfColorsRequired = data.numberOfColorsRequired ? 1 : 0;
        _value.numberOfApplicationsRequired = data.numberOfApplicationsRequired ? 1 : 0;
        _value.retailPriceRequired = data.retailPriceRequired ? 1 : 0;
        _value.sewCostRequired = data.sewCostRequired ? 1 : 0;
        _value.stoneCostRequired = data.stoneCostRequired ? 1 : 0;
        _value.colorRequired = data.colorRequired ? 1 : 0;
        _value.allstarItemClassCode = data.allstarItemClassCode;
        _value.status = data.status;

        save(_value);
        form.reset();
    };

    const save = (value: CustomLtrSetup) => {
        if (isNew.current) {
            MaintenanceService.addCustomLtrSetup(value).then(() => {
                setUpdateTrigger(prev => prev + 1);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Custom Letter Setup Created', life: 3000 });
                setSingleValue(empty);
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Custom Letter Setup', life: 3000 });
            });
        } else {
            MaintenanceService.updateCustomLtrSetup(value).then(() => {
                setUpdateTrigger(prev => prev + 1);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Custom Letter Setup Updated', life: 3000 });
                setSingleValue(empty);
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Custom Letter Setup', life: 3000 });
            });
        }
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<CustomLtrSetup[]>) => {
        let selectedIndex = listValues.findIndex(v => v.rowId === (rowData.value as CustomLtrSetup).rowId);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].rowId}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'prefix':
                return prefixEditor(options);

            case 'suffix':
                return suffixEditor(options);

            case 'template':
                return templateEditor(options);

            case 'itemClassCode':
                return itemClassCodeEditor(options);

            case 'capacityCode':
                return capacityCodeEditor(options);

            case 'description':
                return descriptionEditor(options);

            case 'minuteEntryRequired':
                return minuteEntryRequiredEditor(options);

            case 'cutCostRequired':
                return cutCostRequiredEditor(options);

            case 'numberOfColorsRequired':
                return numberOfColorsRequiredEditor(options);

            case 'numberOfApplicationsRequired':
                return numberOfApplicationsRequiredEditor(options);

            case 'retailPriceRequired':
                return retailPriceRequiredEditor(options);

            case 'sewCostRequired':
                return sewCostRequiredEditor(options);

            case 'stoneCostRequired':
                return stoneCostRequiredEditor(options);

            case 'colorRequired':
                return colorRequiredEditor(options);

            case 'allstarItemClassCode':
                return allstarItemClassCodeEditor(options);

            case 'status':
                return statusEditor(options);

            default:
                return null;
        }
    }

    const prefixEditor = (options: any) => {
        return (
            <Controller
                name="prefixEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Prefix is required.',
                    maxLength: {
                        value: 20,
                        message: 'Prefix must be at most 20 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.prefix = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={20} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.prefix = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Prefix" />
                        </>
                    )
                }}
            />
        );
    }

    const suffixEditor = (options: any) => {
        return (
            <Controller
                name="suffixEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Suffix is required.',
                    maxLength: {
                        value: 20,
                        message: 'Suffix must be at most 20 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.suffix = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={20} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.suffix = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Suffix" />
                        </>
                    )
                }}
            />
        );
    }

    const templateEditor = (options: any) => {
        return (
            <Controller
                name="templateEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Template is required.',
                    maxLength: {
                        value: 50,
                        message: 'Template must be at most 50 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.template = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={50} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.template = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Template" />
                        </>
                    )
                }}
            />
        );
    }

    const descriptionEditor = (options: any) => {
        return (
            <Controller
                name="descriptionEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Description is required.',
                    maxLength: {
                        value: 100,
                        message: 'Description must be at most 100 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.description = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={100} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.description = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }}
            />
        );
    }    

    const itemClassCodeEditor = (options: any) => {
        return (
            <Controller
                name="itemClassCodeEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Item Class Code is required.',
                    maxLength: {
                        value: 10,
                        message: 'Item Class Code must be at most 10 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.itemClassCode = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={10} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.itemClassCode = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Item Class Code" />
                        </>
                    )
                }}
            />
        );
    }

    const capacityCodeEditor = (options: any) => {
        return (
            <Controller
                name="capacityCodeEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Capacity Code is required.',
                    maxLength: {
                        value: 5,
                        message: 'Capacity Code must be at most 5 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.capacityCode = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={5} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.capacityCode = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Capacity Code" />
                        </>
                    )
                }}
            />
        );
    }

    const minuteEntryRequiredEditor = (options: any) => {
        return (
            <Controller
                name="minuteEntryRequiredEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.minuteEntryRequired = field.value ? 1 : 0;
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 1}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.minuteEntryRequired = checked ? 1 : 0;
                                    field.onChange(checked ? 1 : 0);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const cutCostRequiredEditor = (options: any) => {
        return (
            <Controller
                name="cutCostRequiredEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.cutCostRequired = field.value ? 1 : 0;
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 1}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.cutCostRequired = checked ? 1 : 0;
                                    field.onChange(checked ? 1 : 0);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const numberOfColorsRequiredEditor = (options: any) => {
        return (
            <Controller
                name="numberOfColorsRequiredEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.numberOfColorsRequired = field.value ? 1 : 0;
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 1}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.numberOfColorsRequired = checked ? 1 : 0;
                                    field.onChange(checked ? 1 : 0);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const numberOfApplicationsRequiredEditor = (options: any) => {
        return (
            <Controller
                name="numberOfApplicationsRequiredEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.numberOfApplicationsRequired = field.value ? 1 : 0;
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 1}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.numberOfApplicationsRequired = checked ? 1 : 0;
                                    field.onChange(checked ? 1 : 0);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }
    
    const retailPriceRequiredEditor = (options: any) => {
        return (
            <Controller
                name="retailPriceRequiredEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.retailPriceRequired = field.value ? 1 : 0;
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 1}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.retailPriceRequired = checked ? 1 : 0;
                                    field.onChange(checked ? 1 : 0);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const sewCostRequiredEditor = (options: any) => {
        return (
            <Controller
                name="sewCostRequiredEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.sewCostRequired = field.value ? 1 : 0;
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 1}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.sewCostRequired = checked ? 1 : 0;
                                    field.onChange(checked ? 1 : 0);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const stoneCostRequiredEditor = (options: any) => {
        return (
            <Controller
                name="stoneCostRequiredEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.stoneCostRequired = field.value ? 1 : 0;
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 1}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.stoneCostRequired = checked ? 1 : 0;
                                    field.onChange(checked ? 1 : 0);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const colorRequiredEditor = (options: any) => {
        return (
            <Controller
                name="colorRequiredEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.colorRequired = field.value ? 1 : 0;
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 1}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.colorRequired = checked ? 1 : 0;
                                    field.onChange(checked ? 1 : 0);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const allstarItemClassCodeEditor = (options: any) => {
        return (
            <Controller
                name="allstarItemClassCodeEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Allstar Item Class Code is required.',
                    maxLength: {
                        value: 10,
                        message: 'Allstar Item Class Code must be at most 10 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.allstarItemClassCode = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={10} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.allstarItemClassCode = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Allstar Item Class Code" />
                        </>
                    )
                }}
            />
        );
    }

    const statusEditor = (options: any) => {
        return (
            <Controller
                name="statusEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Status is required.',
                    maxLength: {
                        value: 1,
                        message: 'Status must be at most 1 character.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.status = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={status} optionLabel="name" optionValue="code" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.status = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }}
            />
        );
    }

    const rowEditorTemplate = (rowData: CustomLtrSetup, props: any) => {
        const rowEditor = props.rowEditor;
        if (rowEditor.editing) {
            isNew.current = false;
    
            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (
                            !formEdit.getFieldState("prefixEdit").invalid &&
                            !formEdit.getFieldState("suffixEdit").invalid &&
                            !formEdit.getFieldState("templateEdit").invalid &&
                            !formEdit.getFieldState("itemClassCodeEdit").invalid &&
                            !formEdit.getFieldState("capacityCodeEdit").invalid &&
                            !formEdit.getFieldState("descriptionEdit").invalid &&
                            !formEdit.getFieldState("statusEdit").invalid
                        ) {
                            let _singleValue = { ...singleValue };
                            _singleValue.rowId = rowData.rowId;
    
                            save(_singleValue);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />
    
                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }
    
    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: CustomLtrSetup) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteCustomLtrSetup(singleValue.rowId).then((data: boolean) => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <div>
            <Toast ref={toast} />
            <Panel header="Add Custom Lettering" className="mt-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="prefix"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Prefix is required.',
                                    maxLength: {
                                        value: 20,
                                        message: 'Prefix must be at most 20 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Prefix</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={20} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Prefix" />
                                        {getErrorMessage('prefix')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="suffix"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Suffix is required.',
                                    maxLength: {
                                        value: 20,
                                        message: 'Suffix must be at most 20 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Suffix</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={20} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Suffix" />
                                        {getErrorMessage('suffix')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="template"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Template is required.',
                                    maxLength: {
                                        value: 50,
                                        message: 'Template must be at most 50 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Template</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={50} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Template" />
                                        {getErrorMessage('template')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="itemClassCode"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Item Class Code is required.',
                                    maxLength: {
                                        value: 10,
                                        message: 'Item Class Code must be at most 10 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Item Class Code</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={10} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Item Class Code" />
                                        {getErrorMessage('itemClassCode')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="capacityCode"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Capacity Code is required.',
                                    maxLength: {
                                        value: 5,
                                        message: 'Capacity Code must be at most 5 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Capacity Code</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={5} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Capacity Code" />
                                        {getErrorMessage('capacityCode')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="description"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.',
                                    maxLength: {
                                        value: 100,
                                        message: 'Description must be at most 100 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={100} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                                        {getErrorMessage('description')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="minuteEntryRequired"
                                control={form.control}
                                defaultValue={0}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Minute Entry Required</label><br />
                                        <Checkbox inputId={field.name} checked={field.value === 1} inputRef={field.ref} className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked ? 1 : 0)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="cutCostRequired"
                                control={form.control}
                                defaultValue={0}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Cut Cost Required</label><br />
                                        <Checkbox inputId={field.name} checked={field.value === 1} inputRef={field.ref} className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked ? 1 : 0)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="numberOfColorsRequired"
                                control={form.control}
                                defaultValue={0}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Number of Colors Required</label><br />
                                        <Checkbox inputId={field.name} checked={field.value === 1} inputRef={field.ref} className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked ? 1 : 0)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="numberOfApplicationsRequired"
                                control={form.control}
                                defaultValue={0}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Number of Applications Required</label><br />
                                        <Checkbox inputId={field.name} checked={field.value === 1} inputRef={field.ref} className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked ? 1 : 0)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="retailPriceRequired"
                                control={form.control}
                                defaultValue={0}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Retail Price Required</label><br />
                                        <Checkbox inputId={field.name} checked={field.value === 1} inputRef={field.ref} className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked ? 1 : 0)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="sewCostRequired"
                                control={form.control}
                                defaultValue={0}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Sew Cost Required</label><br />
                                        <Checkbox inputId={field.name} checked={field.value === 1} inputRef={field.ref} className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked ? 1 : 0)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="stoneCostRequired"
                                control={form.control}
                                defaultValue={0}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Stone Cost Required</label><br />
                                        <Checkbox inputId={field.name} checked={field.value === 1} inputRef={field.ref} className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked ? 1 : 0)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="colorRequired"
                                control={form.control}
                                defaultValue={0}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Color Required</label><br />
                                        <Checkbox inputId={field.name} checked={field.value === 1} inputRef={field.ref} className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked ? 1 : 0)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="allstarItemClassCode"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Allstar Item Class Code is required.',
                                    maxLength: {
                                        value: 10,
                                        message: 'Allstar Item Class Code must be at most 10 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Allstar Item Class Code</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={10} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Allstar Item Class Code" />
                                        {getErrorMessage('allstarItemClassCode')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="status"
                                control={form.control}
                                defaultValue="A"
                                rules={{
                                    required: 'Status is required.',
                                    maxLength: {
                                        value: 1,
                                        message: 'Status must be at most 1 character.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Status</label>
                                        <Dropdown id={field.name} value={field.value} options={status} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.value)} placeholder="Select Status" />
                                        {getErrorMessage('status')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
                <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                    dataKey="rowId" size="small" rowHover={true} loading={loading}
                    scrollable scrollHeight="calc(100vh - 23.9rem)"
                    paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                    filters={filters} header={header} onValueChange={filteredData => setListFilteredData(filteredData)}
                    emptyMessage="No Custom Letter Setup records found.">
                    <Column field="prefix" header="Prefix" sortable body={prefixTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="suffix" header="Suffix" sortable body={suffixTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="template" header="Template" sortable body={templateTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="itemClassCode" header="Item Class Code" sortable body={itemClassCodeTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="capacityCode" header="Capacity Code" sortable body={capacityCodeTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="description" header="Description" sortable body={descriptionTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="minuteEntryRequired" header="Minute Entry Required" sortable body={minuteEntryRequiredTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="cutCostRequired" header="Cut Cost Required" sortable body={cutCostRequiredTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="numberOfColorsRequired" header="Number of Colors Required" sortable body={numberOfColorsRequiredTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="numberOfApplicationsRequired" header="Number of Applications Required" sortable body={numberOfApplicationsRequiredTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="retailPriceRequired" header="Retail Price Required" sortable body={retailPriceRequiredTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="sewCostRequired" header="Sew Cost Required" sortable body={sewCostRequiredTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="stoneCostRequired" header="Stone Cost Required" sortable body={stoneCostRequiredTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="colorRequired" header="Color Required" sortable body={colorRequiredTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="allstarItemClassCode" header="Allstar Item Class Code" sortable body={allstarItemClassCodeTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column field="status" header="Status" sortable body={statusTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                    <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                </DataTable>

                <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                        {singleValue && (
                            <span>
                                Are you sure you want to delete <b>{singleValue.prefix} - {singleValue.suffix}</b>?
                            </span>
                        )}
                    </div>
                </Dialog>
            </Panel>
        </div>
    );
}
